import axiosInstance from "../config/axiosInstance";
import API from "../config/config";

class JoiningFeeService {
  static async getConfig() {
    const response = await axiosInstance.get(API.ADMIN.JOINING_FEE_CONFIG);
    return response.data;
  }

  static async updateConfig(baseAmount) {
    const response = await axiosInstance.put(API.ADMIN.JOINING_FEE_CONFIG, {
      baseAmount,
    });
    return response.data;
  }

  static async getPayments(params = {}) {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        query.append(key, value);
      }
    });
    const response = await axiosInstance.get(
      `${API.ADMIN.JOINING_FEE_PAYMENTS}?${query}`
    );
    return response.data;
  }
}

export default JoiningFeeService;
